export default {
  en: {
    '★ Prime 旗舰': '★ Prime Flagship',
    'Prime 旗舰': 'Prime Flagship',
    '版本 3.0': 'Version 3.0',
    '年100%+': '100%+ yearly',
    '年200%+': '200%+ yearly',
    '年400%+': '400%+ yearly',
    '年800%+': '800%+ yearly',
    '年1000%+': '1000%+ yearly',
    '年2000%+': '2000%+ yearly',
    '接口请求失败': 'API request failed',
    '接口未返回数据': 'API returned no data',
    '读取失败': 'failed to load',
    '测试名额数据异常，暂不能创建': 'beta quota data is invalid; creation is unavailable',
    '测试名额已满': 'beta quota is full',
    '开放时间数据异常，暂不能创建': 'availability time is invalid; creation is unavailable',
    '可创建数量数据异常，暂不能创建': 'creation quota is invalid; creation is unavailable',
    '可创建数量已用完': 'creation quota has been used up',
    '尚未到开放时间': 'is not available yet',
    'AI 智能产品': 'AI smart product',
    'AI 自动抓取并匹配交易币种，创建后根据市场状态自动运行。': 'AI automatically detects and matches trading coins, then runs according to market conditions after creation.',
    'Binance 现货余额': 'Binance spot balance',
    'BTC 专用期现版本，提交 version=5。': 'BTC-specific spot-futures version using version=5.',
    '币种最小仓位': 'Minimum coin position',
    '策略币种列表': 'Strategy coin list',
    '策略可创建数量数据尚未加载': 'Strategy creation quota has not loaded',
    '低风险合约策略，币种与最小仓位均以接口返回为准。': 'Low-risk contract strategy. Coins and minimum positions follow the API response.',
    '多空对冲震荡套利，支持止损、风险等级和最大持仓设置。': 'Long-short hedged range arbitrage with stop-loss, risk level, and maximum-position settings.',
    '合约 AI': 'Contract AI',
    '合约 AI 单向版': 'Contract AI One-way',
    '合约 AI 闪电版': 'Contract AI Lightning',
    '合约AI交易 (单向版)': 'Contract AI Trading (One-way)',
    '合约AI交易 (闪电版)': 'Contract AI Trading (Lightning)',
    '机器人页面尚未加载策略可用名额': 'Strategy quota has not loaded on the Bots page',
    '交易所可用余额': 'Exchange available balance',
    '期现 AI BTC 版': 'Spot-Futures AI BTC',
    '期现 AI 普通版': 'Spot-Futures AI Standard',
    '期现 AI 闪电版': 'Spot-Futures AI Lightning',
    '期现AI交易 (BTC 版)': 'Spot-Futures AI Trading (BTC)',
    '期现AI交易 (普通版)': 'Spot-Futures AI Trading (Standard)',
    '期现AI交易 (闪电版)': 'Spot-Futures AI Trading (Lightning)',
    '期现闪电版，提交 version=3，与原项目保持一致。': 'Spot-futures Lightning version using version=3, consistent with the original project.',
    '闪电版合约策略，创建参数与原项目 speed=1 完全一致。': 'Lightning contract strategy using the original project’s speed=1 parameters.',
    '现货交易对': 'Spot trading pairs',
    '现货与合约对冲，币种和最小仓位由期现接口实时返回。': 'Spot-contract hedging; coins and minimum positions are returned by the spot-futures API in real time.',
    '支持做多或做空，Gate.io 与 Bybit 仅开放该合约版本。': 'Supports long or short positions. Gate.io and Bybit offer only this contract version.',
    '主流币种 AI 合约策略，可按接口返回范围调整杠杆。': 'AI contract strategy for major coins with leverage adjustable within the API range.',
    '主推': 'Featured',
    'USDT汇率': 'USDT exchange rate',
    '策略可用名额': 'Strategy quota',
    '点卡额度': 'Point packages',
    '公开开单榜': 'Public trade ranking',
    '公开收益榜': 'Public earnings ranking',
    '机器人风险': 'Bot risk',
    '机器人列表': 'Bot list',
    '交易所类型无效': 'Invalid exchange type',
    '累计收益曲线': 'Cumulative earnings curve',
    '平台公开数据': 'Platform public data',
    '燃料点卡记录': 'Fuel and point records',
    '收益走势图': 'Earnings trend chart',
    '我的收益排名': 'My earnings rank',
    '用户信息': 'User information',
    '用户资产': 'User assets',
    '月度收益曲线': 'Monthly earnings curve',
    '资产变动记录': 'Asset change records',
    '策略收益': 'Strategy earnings',
    '持仓明细': 'Position details',
    '当前策略没有该专项操作': 'This operation is not available for the current strategy',
    '可用余额': 'Available balance',
    '买入委托': 'Buy orders',
    '卖出委托': 'Sell orders',
    '收益曲线': 'Earnings curve',
    '委托/成交记录': 'Order/trade records',
    '委托记录': 'Order records',
    '未知的策略操作': 'Unknown strategy action',
    '最小下单量': 'Minimum order size',
    '最新行情': 'Latest market price',
    '当前客服信息获取失败': 'Failed to load current support information',
    '客服会话初始化失败': 'Failed to initialize support session',
    '客服会话关闭失败': 'Failed to close support session',
    '图片上传结果无效': 'Invalid image upload result',
    '图片上传失败': 'Image upload failed',
    '该策略没有可用的对应接口': 'No API is available for this strategy',
    '马丁策略详情读取失败': 'Failed to load Martingale strategy details',
    '当前机器人状态不允许启动或关闭': 'The current bot state does not allow starting or stopping'
  },
  ko: {
    '★ Prime 旗舰': '★ Prime 플래그십',
    'Prime 旗舰': 'Prime 플래그십',
    '版本 3.0': '버전 3.0',
    '年100%+': '연 100%+',
    '年200%+': '연 200%+',
    '年400%+': '연 400%+',
    '年800%+': '연 800%+',
    '年1000%+': '연 1000%+',
    '年2000%+': '연 2000%+',
    '接口请求失败': 'API 요청 실패',
    '接口未返回数据': 'API가 데이터를 반환하지 않았습니다',
    '读取失败': '로딩 실패',
    '测试名额数据异常，暂不能创建': '베타 할당량 데이터가 올바르지 않아 생성할 수 없습니다',
    '测试名额已满': '베타 할당량이 가득 찼습니다',
    '开放时间数据异常，暂不能创建': '공개 시간 데이터가 올바르지 않아 생성할 수 없습니다',
    '可创建数量数据异常，暂不能创建': '생성 할당량 데이터가 올바르지 않아 생성할 수 없습니다',
    '可创建数量已用完': '생성 할당량을 모두 사용했습니다',
    '尚未到开放时间': '아직 이용 가능 시간이 아닙니다',
    'AI 智能产品': 'AI 스마트 상품',
    'AI 自动抓取并匹配交易币种，创建后根据市场状态自动运行。': 'AI가 거래 코인을 자동으로 감지하고 매칭하며 생성 후 시장 상태에 따라 자동 실행됩니다.',
    'Binance 现货余额': 'Binance 현물 잔액',
    'BTC 专用期现版本，提交 version=5。': 'version=5를 사용하는 BTC 전용 현물-선물 버전입니다.',
    '币种最小仓位': '코인 최소 포지션',
    '策略币种列表': '전략 코인 목록',
    '策略可创建数量数据尚未加载': '전략 생성 할당량이 아직 로드되지 않았습니다',
    '低风险合约策略，币种与最小仓位均以接口返回为准。': '낮은 위험의 계약 전략이며 코인과 최소 포지션은 API 응답을 따릅니다.',
    '多空对冲震荡套利，支持止损、风险等级和最大持仓设置。': '롱-숏 헤지 구간 차익거래로 손절, 위험 등급 및 최대 포지션 설정을 지원합니다.',
    '合约 AI': '계약 AI',
    '合约 AI 单向版': '계약 AI 단방향',
    '合约 AI 闪电版': '계약 AI 라이트닝',
    '合约AI交易 (单向版)': '계약 AI 거래 (단방향)',
    '合约AI交易 (闪电版)': '계약 AI 거래 (라이트닝)',
    '机器人页面尚未加载策略可用名额': '봇 페이지의 전략 할당량이 아직 로드되지 않았습니다',
    '交易所可用余额': '거래소 가용 잔액',
    '期现 AI BTC 版': '현물-선물 AI BTC',
    '期现 AI 普通版': '현물-선물 AI 표준',
    '期现 AI 闪电版': '현물-선물 AI 라이트닝',
    '期现AI交易 (BTC 版)': '현물-선물 AI 거래 (BTC)',
    '期现AI交易 (普通版)': '현물-선물 AI 거래 (표준)',
    '期现AI交易 (闪电版)': '현물-선물 AI 거래 (라이트닝)',
    '期现闪电版，提交 version=3，与原项目保持一致。': '기존 프로젝트와 동일하게 version=3을 사용하는 현물-선물 라이트닝 버전입니다.',
    '闪电版合约策略，创建参数与原项目 speed=1 完全一致。': '기존 프로젝트의 speed=1 매개변수와 동일한 라이트닝 계약 전략입니다.',
    '现货交易对': '현물 거래 페어',
    '现货与合约对冲，币种和最小仓位由期现接口实时返回。': '현물-계약 헤지이며 코인과 최소 포지션은 현물-선물 API에서 실시간 반환됩니다.',
    '支持做多或做空，Gate.io 与 Bybit 仅开放该合约版本。': '롱 또는 숏을 지원하며 Gate.io와 Bybit은 이 계약 버전만 제공합니다.',
    '主流币种 AI 合约策略，可按接口返回范围调整杠杆。': '주요 코인용 AI 계약 전략으로 API 범위 내에서 레버리지를 조정할 수 있습니다.',
    '主推': '주요 추천',
    'USDT汇率': 'USDT 환율',
    '策略可用名额': '전략 할당량',
    '点卡额度': '포인트 상품',
    '公开开单榜': '공개 거래 순위',
    '公开收益榜': '공개 수익 순위',
    '机器人风险': '봇 위험',
    '机器人列表': '봇 목록',
    '交易所类型无效': '유효하지 않은 거래소 유형',
    '累计收益曲线': '누적 수익 곡선',
    '平台公开数据': '플랫폼 공개 데이터',
    '燃料点卡记录': '연료 및 포인트 기록',
    '收益走势图': '수익 추세 차트',
    '我的收益排名': '내 수익 순위',
    '用户信息': '사용자 정보',
    '用户资产': '사용자 자산',
    '月度收益曲线': '월간 수익 곡선',
    '资产变动记录': '자산 변동 기록',
    '策略收益': '전략 수익',
    '持仓明细': '포지션 상세',
    '当前策略没有该专项操作': '현재 전략에서는 이 작업을 사용할 수 없습니다',
    '可用余额': '가용 잔액',
    '买入委托': '매수 주문',
    '卖出委托': '매도 주문',
    '收益曲线': '수익 곡선',
    '委托/成交记录': '주문/체결 기록',
    '委托记录': '주문 기록',
    '未知的策略操作': '알 수 없는 전략 작업',
    '最小下单量': '최소 주문 수량',
    '最新行情': '최신 시장가',
    '当前客服信息获取失败': '현재 고객 지원 정보를 불러오지 못했습니다',
    '客服会话初始化失败': '고객 지원 세션 초기화 실패',
    '客服会话关闭失败': '고객 지원 세션 종료 실패',
    '图片上传结果无效': '유효하지 않은 이미지 업로드 결과',
    '图片上传失败': '이미지 업로드 실패',
    '该策略没有可用的对应接口': '이 전략에 사용할 수 있는 API가 없습니다',
    '马丁策略详情读取失败': '마틴 전략 상세 로딩 실패',
    '当前机器人状态不允许启动或关闭': '현재 봇 상태에서는 시작하거나 끌 수 없습니다'
  }
}
